// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"3f10432d","613":"14f87a8b"}[chunkId] + ".chunk.css";
};